import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { format, isBefore, startOfTomorrow } from 'date-fns';

const boxStyles = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gridColumn: '1/3',
  height: 61,
  justifyContent: 'center',
  mb: 3,
  pb: 1,
  pt: 1,
};

const ExpirationDateDisplay = ({ date }) => {
  const dateObj = new Date(date);
  const isExpired = isBefore(dateObj, startOfTomorrow());
  const formattedDate = format(dateObj, 'MM/dd/yyyy');

  // prettier-ignore
  const label = isExpired 
    ? 'Certificate Expired' 
    : 'Certificate Expiration';

  // prettier-ignore
  const expiredStyles = {
    backgroundColor: isExpired 
      ? 'error.light' 
      : 'graphic.lighter',
  };

  // prettier-ignore
  const dateStyles = {
    color: isExpired 
      ? 'error.dark' 
      : 'text.primary',
  };

  return (
    <Box sx={{ ...boxStyles, ...expiredStyles }}>
      <Typography sx={dateStyles} variant="subtitle1">
        {formattedDate}
      </Typography>
      <Typography sx={{ color: 'secondary' }} variant="body2">
        {label}
      </Typography>
    </Box>
  );
};

ExpirationDateDisplay.propTypes = {
  date: PropTypes.string.isRequired,
};

export default ExpirationDateDisplay;
